module.exports = __webpack_public_path__ + "img/prize-2.c01838cb.jpg";